import React from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import HowItWorks from "@/components/site/HowItWorks";
import Services from "@/components/site/Services";
import WhyUs from "@/components/site/WhyUs";
import Booking from "@/components/site/Booking";
import Testimonials from "@/components/site/Testimonials";
import Location from "@/components/site/Location";
import Footer from "@/components/site/Footer";
import VoucherBanner from "@/components/site/VoucherBanner";
import FamilyStory from "@/components/site/FamilyStory";
import MeetFamily from "@/components/site/MeetFamily";
import CoverageMap from "@/components/site/CoverageMap";
import FAQ from "@/components/site/FAQ";
import MobileCTABar from "@/components/site/MobileCTABar";
import VeteransHonor from "@/components/site/VeteransHonor";
import BlogPreview from "@/components/site/BlogPreview";

export default function Home() {
  return (
    <div className="min-h-screen bg-white text-brand-navy font-body pb-20 lg:pb-0">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <VoucherBanner />
        <MeetFamily />
        <HowItWorks />
        <Services />
        <FamilyStory />
        <WhyUs />
        <CoverageMap />
        <Booking />
        <VeteransHonor />
        <Testimonials />
        <FAQ />
        <BlogPreview />
        <Location />
      </main>
      <Footer />
      <MobileCTABar />
    </div>
  );
}
